import type {
  EvaluationReduxAction,
  ReduxAction,
} from "ee/constants/ReduxActionConstants";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export const batchAction = (action: EvaluationReduxAction<any>) => {
  return {
    type: ReduxActionTypes.BATCHED_UPDATE,
    payload: action,
  };
};

export type BatchAction<T> = ReduxAction<EvaluationReduxAction<T>>;

export const batchActionSuccess = (actions: ReduxAction<any>[]) => ({
  type: ReduxActionTypes.BATCH_UPDATES_SUCCESS,
  payload: actions,
});
